import { ShopContainer } from "../ShopContainer";
import React, {useContext, useState} from "react";
import {HardwareGeneric} from "./HardwareGeneric";
import {HardwareSwitcher} from "../../quote/hardware/HardwareSwitcher";
import {Grid, Tab, Tabs} from "@mui/material";
import {useTabQueryParam} from "../../../../misc/userpref/useTabQueryParam";
import {HardwareScheduleBtn} from "../../quote/hardware/HardwareScheduleBtn";
import {HardwarePhaseFilter} from "../../quote/hardware/HardwarePhaseFilter";
import {HardwareDistributorOverrideInner} from "./HardwareDistributorOverride";
import {useReSequence} from "../../quote/hardware/HardwareReSequence";
import {HardwareViewMode, HardwareViewModeProvider, ShowByUsSuppliers} from "../../quote/hardware/HardwareViewMode";
import {CleanupGroups} from "../../quote/hardware/CleanupGroups";
import {EventEmitter} from "nate-react-api-helpers";
import {TransferProducts} from "../../quote/hardware/TransferProducts";
import {CopyHardwareDialog} from "./CopyHardwareFromQuoteMode";
import {MenuButton} from "../../../logistics/purchasing/MenuButton";
import {SmallGreyButton} from "../../../../misc/SmallGreyButton";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import {tabGroup} from "../../../logistics/purchasing/PartsToSource";
import {TabWrapper} from "../TabWrapper";
import {HardwareMisc} from "./HardwareMisc";
import {ChangePreviewContext} from "../ShopDrawingChangePreview";
import {ManageProjectSuppliers} from "./ManageProjectSuppliers";
import {ProjectActions} from "../ProjectActions";

export const HwForceUpdate = new EventEmitter<number>()

export function Hardware() {
    const cacheBuster = EventEmitter.reactValue(HwForceUpdate)

    const [showDistributors, setShowDistributors] = useState(false);
    const [showCleanupGroups, setShowCleanupGroups] = useState(false);
    const [showCopyFromQuote, setShowCopyFromQuote] = useState(false);
    const [showSuppliers, setShowSuppliers] = useState(false);
    const reSequence = useReSequence({
        onDone: () => HwForceUpdate.emit(Date.now()),
    });
    const [tab, setTab, dt] = useTabQueryParam({page: "shopdrawing.hardware", urlKey: "t", fallback: "schedule", allowed: ["schedule", "misc"]});

    const changePreviewCtx = useContext(ChangePreviewContext);

    return (<HardwareViewModeProvider key={cacheBuster}>
        <ShopContainer
            name={<HardwareSwitcher />}
            actions={<>
                {tab === "schedule" && <Grid container spacing={1}>
                        <Grid item>
                            <TransferProducts />
                        </Grid>
                        <Grid item>
                            <HardwareScheduleBtn />
                        </Grid>
                        <Grid item>
                            <HardwarePhaseFilter />
                        </Grid>
                        {!changePreviewCtx.enabled && <Grid item>
                            <MenuButton
                                renderButton={p => {
                                    return <SmallGreyButton endIcon={<ArrowDropDownIcon />} {...p} />
                                }}
                                options={[
                                {
                                    name: "Change Distributors",
                                    onClick: () => setShowDistributors(true)
                                }, {
                                        name: "Copy from Quote",
                                        onClick: () => setShowCopyFromQuote(true)
                                }, {
                                    name: "Cleanup Groups",
                                    onClick: () => setShowCleanupGroups(true)
                                }, {
                                    name: "Resequence",
                                    onClick: () => {
                                        reSequence();
                                    }
                                },
                                {
                                    name: "Supplied Categories",
                                    onClick: () => setShowSuppliers(true)
                                }
                                ]}>Actions</MenuButton>
                        </Grid>}

                        {showDistributors && <HardwareDistributorOverrideInner onClose={() => setShowDistributors(false)} />}
                        {showCleanupGroups && <CleanupGroups onDone={() => setShowCleanupGroups(false)} />}
                        {showCopyFromQuote && <CopyHardwareDialog onClose={() => setShowCopyFromQuote(false)} />}
                        {showSuppliers && <ManageProjectSuppliers onDone={() => {
                            setShowSuppliers(false);
                            HwForceUpdate.emit(Date.now());
                        }} />}
                </Grid>}
        </>}
            overrideRightActions={<>
                <div style={{display: "flex", flexDirection: "row"}}>
                    <HardwareViewMode />
                    <ShowByUsSuppliers />
                    <ProjectActions />
                </div>
            </>}
        >
            <TabWrapper>
                <Tabs className={tabGroup} value={tab} onChange={(e, value) => setTab(value)}>
                    <Tab label="Schedule" value="schedule" {...dt.tabProps("schedule")} />
                    <Tab label="Misc" value="misc" {...dt.tabProps("misc")} />
                </Tabs>
                {dt.controls}
            </TabWrapper>

            {tab === "schedule" && <HardwareGeneric />}
            {tab === "misc" && <HardwareMisc />}
        </ShopContainer>
    </HardwareViewModeProvider>);
}